module.exports = __webpack_public_path__ + "static/img/2032.82c320c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2032.jpg
// module id = 322
// module chunks = 0